import { OneWayInServiceUpsertDto } from 'src/api/v2';
import useServiceSubForm, { extractSubData, SubFormProps, SubFormReturn } from '../use-service-sub-form';
import { useTranslation } from 'react-i18next';

export type DeliveryFields =
  | 'deliveryTypes'
  | 'deliveryDescription'
  | 'applicationDeadline'
  | 'hasUserFee'
  | 'userFeeComments';

export type DeliveryData = Pick<OneWayInServiceUpsertDto, DeliveryFields>;

const useDeliveryForm = ({
  data,
  updateData,
  errors,
  setErrors,
}: SubFormProps<DeliveryData>): SubFormReturn<DeliveryData, DeliveryFields> => {
  const { t } = useTranslation('services');

  const rules: Partial<Record<keyof OneWayInServiceUpsertDto, any>> = {
    deliveryTypes: { required: t('delivery.type.required') },
    deliveryDescription: { required: t('delivery.description.required') },
    applicationDeadline: { required: data.applicationDeadline ? t('delivery.deadline.required') : false },
    hasUserFee: {
      validate: (value: boolean | null) => {
        return value === null || value === undefined ? t('delivery.userFee.required') : true;
      },
    },
    userFeeComments: { required: data.hasUserFee ? t('delivery.userFeeComments.required') : false },
  };

  const extractDeliveryFields = (data: OneWayInServiceUpsertDto): DeliveryData => {
    return extractSubData(data, [
      'deliveryTypes',
      'deliveryDescription',
      'applicationDeadline',
      'hasUserFee',
      'userFeeComments',
    ]);
  };
  const deliveryFields = extractDeliveryFields(data);
  const { form } = useServiceSubForm<DeliveryData>(deliveryFields, updateData, errors, setErrors);
  const registerWithRules = (field: DeliveryFields) => form.register(field, rules[field]);
  return { form, rules, registerWithRules };
};

export default useDeliveryForm;
